import { BoxTitles } from "@boxes/BoxTitles";
import { Button, Checkbox, Drawer } from "@components";
import { useEffect, useState } from "react";

import { If } from "@components/control-statements";
import styles from "@styles/forms-flow/filtered-audience.module.scss";
import classNames from "classnames/bind";

const css = classNames.bind(styles);

export const ConsumptionMomentsConditionalForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [profile, setProfile] = useState(node?.data || {});

  const getFreshNode = () => {
    return { ...node, data: { ...node.data, ...profile } };
  };

  const emitOnChange = () => {
    onChange && onChange(getFreshNode());
  };

  useEffect(() => {
    visible && profile && emitOnChange();
  }, [profile]);
  useEffect(() => {
    visible && setProfile(node?.data || {});
  }, [node]);

  const isDayPeriodSelected = (day) => {
    return !!profile?.dayPeriods?.periods?.includes(day);
  };

  const isWeekPeriodSelected = (weekPeriod) => {
    return !!profile?.weekPeriods?.periods?.includes(weekPeriod);
  };

  const isYearPeriodSelected = (season) => {
    return !!profile?.yearPeriods?.periods?.includes(season);
  };

  const toggleSection = (section) => {
    setProfile({
      ...profile,
      [section]: { ...profile[section], active: !profile[section]?.active },
    });
  };

  const toggleDayPeriod = (day) => {
    setProfile((prevState) => {
      const periods = [...(prevState?.dayPeriods?.periods || [])];
      if (periods.includes(day)) {
        return {
          ...prevState,
          dayPeriods: {
            ...(prevState?.dayPeriods || {}),
            periods: periods.filter((d) => d != day),
          },
        };
      } else {
        return {
          ...prevState,
          dayPeriods: {
            ...(prevState?.dayPeriods || {}),
            periods: [...periods, day],
          },
        };
      }
    });
  };

  const toggleWeekPeriod = (weekPeriod) => {
    setProfile((prevState) => {
      const periods = [...(prevState?.weekPeriods?.periods || [])];
      if (periods.includes(weekPeriod)) {
        return {
          ...prevState,
          weekPeriods: {
            ...(prevState?.weekPeriods || {}),
            periods: periods.filter((d) => d != weekPeriod),
          },
        };
      } else {
        return {
          ...prevState,
          weekPeriods: {
            ...(prevState?.weekPeriods || {}),
            periods: [...periods, weekPeriod],
          },
        };
      }
    });
  };

  const toggleYearPeriod = (season) => {
    setProfile((prevState) => {
      const periods = [...(prevState?.yearPeriods?.periods || [])];
      if (periods.includes(season)) {
        return {
          ...prevState,
          yearPeriods: {
            ...(prevState?.yearPeriods || {}),
            periods: periods.filter((d) => d != season),
          },
        };
      } else {
        return {
          ...prevState,
          yearPeriods: {
            ...(prevState?.yearPeriods || {}),
            periods: [...periods, season],
          },
        };
      }
    });
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.ConsumptionMomentsFilter}
      footer={
        <Button
          text="Salvar"
          className="w-100"
          onClick={() => onSave(getFreshNode())}
        />
      }
    >
      <Container
        title="Período do dia"
        active={profile?.dayPeriods?.active}
        onToggleActive={() => toggleSection("dayPeriods")}
      >
        <div className={styles.content}>
          <p className={styles.label}>Você deseja usar:</p>
          <div className={styles.options}>
            <div
              className={css({
                option: true,
                selected: isDayPeriodSelected("DAY"),
              })}
              onClick={() => toggleDayPeriod("DAY")}
            >
              <i className="fa fa-sun-bright" />
              <p>Dia</p>
            </div>
            <div
              className={css({
                option: true,
                selected: isDayPeriodSelected("NIGHT"),
              })}
              onClick={() => toggleDayPeriod("NIGHT")}
            >
              <i className="fal fa-moon-stars" />
              <p>Noite</p>
            </div>
            <div
              className={css({
                option: true,
                selected: isDayPeriodSelected("DAWN"),
              })}
              onClick={() => toggleDayPeriod("DAWN")}
            >
              <i className="fal fa-moon" />
              <p>Madrugada</p>
            </div>
          </div>
        </div>
      </Container>
      <Container
        title="Período da semana"
        active={profile?.weekPeriods?.active}
        onToggleActive={() => toggleSection("weekPeriods")}
      >
        <div className={styles.content}>
          <p className={styles.label}>Você deseja usar:</p>
          <div className={styles.options}>
            <div
              className={css({
                option: true,
                selected: isWeekPeriodSelected("WORKINGDAYS"),
              })}
              onClick={() => toggleWeekPeriod("WORKINGDAYS")}
            >
              <i className="fa fa-sun-bright" />
              <p>Dias de semana</p>
            </div>
            <div
              className={css({
                option: true,
                selected: isWeekPeriodSelected("WEEKEND"),
              })}
              onClick={() => toggleWeekPeriod("WEEKEND")}
            >
              <i className="fal fa-moon-stars" />
              <p>Fim de semana</p>
            </div>
          </div>
        </div>
      </Container>
      <Container
        title="Período do ano"
        active={profile?.yearPeriods?.active}
        onToggleActive={() => toggleSection("yearPeriods")}
      >
        <div className={styles.content}>
          <p className={styles.label}>Você deseja usar:</p>
          <div className={styles.options}>
            <div
              className={css({
                option: true,
                selected: isYearPeriodSelected("SUMMER"),
              })}
              onClick={() => toggleYearPeriod("SUMMER")}
            >
              <i className="fal fa-umbrella-beach" />
              <p>Verão</p>
            </div>
            <div
              className={css({
                option: true,
                selected: isYearPeriodSelected("AUTUMN"),
              })}
              onClick={() => toggleYearPeriod("AUTUMN")}
            >
              <i className="fal fa-leaf-maple" />
              <p>Outono</p>
            </div>
            <div
              className={css({
                option: true,
                selected: isYearPeriodSelected("WINTER"),
              })}
              onClick={() => toggleYearPeriod("WINTER")}
            >
              <i className="fal fa-snowflake" />
              <p>Inverno</p>
            </div>
            <div
              className={css({
                option: true,
                selected: isYearPeriodSelected("SPRING"),
              })}
              onClick={() => toggleYearPeriod("SPRING")}
            >
              <i className="fa fa-flower" />
              <p>Primavera</p>
            </div>
          </div>
        </div>
      </Container>
    </Drawer>
  );
};

const Container = ({ title, active, onToggleActive, children }) => {
  const [opened, setOpened] = useState(false);
  return (
    <div className={styles.climateVariant}>
      <div className={styles.header} onClick={() => setOpened(!opened)}>
        <div className="d-flex align-center">
          <Checkbox checked={active} onClick={() => onToggleActive(!active)} />
          <p>{title}</p>
        </div>

        <i
          className={css({ "fal fa-chevron-down": true, collapsed: !opened })}
        />
      </div>
      <If cond={opened}>{children}</If>
    </div>
  );
};
